import { CSSProperties } from 'react';

export const FONT_BOOK: CSSProperties = {
  fontFamily: 'Avenir Book, Arial, Verdana, sans-serif',
  fontWeight: 300,
};

export const FONT_MED: CSSProperties = {
  fontFamily: 'Avenir Medium, Arial, Verdana, sans-serif',
  fontWeight: 500,
};

export const FONT_HEAVY: CSSProperties = {
  fontFamily: 'Avenir Heavy, Arial, Verdana, sans-serif',
  fontWeight: 800,
};

export const FONT_BLACK: CSSProperties = {
  fontFamily: 'Avenir Black, Arial, Verdana, sans-serif',
  fontWeight: 800,
};
